import * as ATypes from '../../shared/actionTypes';

const defaultState = {
  action: null,
  payload_code: null,
  authority: null,
  country: null,
  meta: {
    application_licence_plate: null,
    applications_code: null,
    public_application_types: [],
    public_application_types_error: null,
    public_application_type: null,
    public_application_type_found: false,
  },
  needsDeeplinkRedirection: false,
};

export const deeplinkReducer = (state = defaultState, reduxAction) => {
  switch (reduxAction.type) {
    case ATypes.SET_DEEPLINK_DATA:
      return {
        ...defaultState,
        ...reduxAction.payload,
        meta: {
          ...defaultState.meta,
          ...(reduxAction.payload?.meta || {}),
        },
      };
    case ATypes.CLEAR_DEEPLINK_DATA:
    case 'persist/PURGE':
      return { ...defaultState };
    default:
      return state;
  }
};
